(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('patient-medication-take-missed-reason', {
            parent: 'entity',
            url: '/patient-medication-take-missed-reason',
            data: {
                authorities: [],
                pageTitle: 'PatientMedicationTakeMissedReasons'
            },
            ncyBreadcrumb: {
                label: 'Patient Medication Take Missed Reason'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patient-medication-take-missed-reason/list/patient-medication-take-missed-reason.html',
                    controller: 'PatientMedicationTakeMissedReasonController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
